 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT1COVER from '@/components/Text/1-cover'
 import BACKEDBIRDSFRONT_1 from '@/components/Backed/birdsfront_1'
 import ADD2019FRONTADD from '@/components/Add-2019/Front-add'
 import TEXT2TITLE_PAGE from '@/components/Text/2-title_page'
 import TEXT3DEDICATION from '@/components/Text/3-dedication'
 import TEXT4TOC from '@/components/Text/4-TOC'
 import TEXT5START from '@/components/Text/5-start'
 import TEXT6PART from '@/components/Text/6-part'
 import TEXT7CHAP1 from '@/components/Text/7-chap1'
 import TEXT8CHAP9 from '@/components/Text/8-chap9'
 import TEXT9CHAP24 from '@/components/Text/9-chap24'
 import TEXT10CHAP32 from '@/components/Text/10-chap32'
 import TEXT11CHAP48 from '@/components/Text/11-chap48'
 import TEXTLOVE_1 from '@/components/Text/love_1'
 import TEXTTEASER00 from '@/components/Text/teaser00'
 import TEXTTEASER01COVER from '@/components/Text/teaser01-cover'
 import TEXTTEASER01 from '@/components/Text/teaser01'
 import TEXTTEASER02 from '@/components/Text/teaser02'
 import TEXTTEASER03 from '@/components/Text/teaser03'
 import TEXTBIO from '@/components/Text/bio'
 import TEXT12COPYRIGHT from '@/components/Text/12-copyright'
 import BACKEDBACKAD_1 from '@/components/Backed/backad_1'
 import BACKEDORIMAD_1 from '@/components/Backed/ORIM-ad_1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/4-TOC",
 			"name" : "Text/4-TOC",
 			"component" : TEXT4TOC
 		},
 		{
 			"path" : "/Text/5-start",
 			"name" : "Text/5-start",
 			"component" : TEXT5START
 		},
 		{
 			"path" : "/Text/6-part",
 			"name" : "Text/6-part",
 			"component" : TEXT6PART
 		},
 		{
 			"path" : "/Text/7-chap1",
 			"name" : "Text/7-chap1",
 			"component" : TEXT7CHAP1
 		},
 		{
 			"path" : "/Text/8-chap9",
 			"name" : "Text/8-chap9",
 			"component" : TEXT8CHAP9
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js